import {Component, ElementRef, inject, ViewChild} from '@angular/core';
import {BaseComponentWithDrawer} from "../base-component-with-drawer.component";
import {GlobalModelService} from "../../../services/GlobalModel.service";
import {DxFormComponent} from "devextreme-angular";
import {DeviceType, MetricGroup} from "../../../models/device-type/DeviceType";
import {GetDeviceTypesCB} from "../../../ope/device-type/GetDeviceTypesCB";
import {DeviceTypeOpeService} from "../../../services/ope/deviceTypeOpe.service";
import {GetDeviceTypeCB} from "../../../ope/device-type/GetDeviceTypeCB";
import {PutDeviceTypeCB} from "../../../ope/device-type/PutDeviceTypeCB";
import {DelDeviceTypeCB} from "../../../ope/device-type/DelDeviceTypeCB";
import {DuplicateDeviceTypeCB} from "../../../ope/device-type/DuplicateDeviceTypeCB";
import {Manufacturer} from "../../../models/manufacturer/Manufacturer";
import {GetManufacturersCB} from "../../../ope/manufacturer/GetManufacturersCB";
import {ClickEvent} from "devextreme/ui/button";
import {DelManufacturerCB} from "../../../ope/manufacturer/DelManufacturerCB";
import {DataUnit} from "../../../models/data-unit/DataUnit";
import {GetDataUnitsCB} from "../../../ope/data-unit/GetDataUnitsCB";
import {ProtocolTypeEnum} from "../../../enums/registry/ProtocolTypeEnum";
import {RowStateTracker} from "../../../utils/RowStateTracker";
import {BaseProtocolFormComponent} from "./measures-protocol-forms/base-protocol-form/base-protocol-form.component";

@Component({
  selector: 'app-gateway-device-type',
  templateUrl: './device-type.component.html',
  styleUrls: ['./device-type.component.css', '../../common/drawer-style.css', '../base-component-with-drawer.component.css']
})
export class DeviceTypeComponent extends BaseComponentWithDrawer {
  gmService: GlobalModelService = inject(GlobalModelService);
  deviceTypeOpeService: DeviceTypeOpeService = inject(DeviceTypeOpeService);

  @ViewChild('newDeviceTypeForm', {static: false}) newDeviceTypeForm!: DxFormComponent;
  @ViewChild('editDeviceTypeForm', {static: false}) editDeviceTypeForm!: DxFormComponent;

  @ViewChild('deviceTypeName', {static: false}) deviceTypeH2?: ElementRef;
  @ViewChild('drawerInnerContent', {static: false}) drawerInnerContent?: ElementRef;

  // Metrics-tab grids of the edit drawer and of the "new device type" popup. Only the pair
  // matching the selected protocol is rendered at a time, the others stay undefined.
  @ViewChild('modbusGroupTable', {static: false}) modbusGroupTable?: BaseProtocolFormComponent;
  @ViewChild('s7GroupTable', {static: false}) s7GroupTable?: BaseProtocolFormComponent;
  @ViewChild('modbusMetricTable', {static: false}) modbusMetricTable?: BaseProtocolFormComponent;
  @ViewChild('s7MetricTable', {static: false}) s7MetricTable?: BaseProtocolFormComponent;
  @ViewChild('newModbusGroupTable', {static: false}) newModbusGroupTable?: BaseProtocolFormComponent;
  @ViewChild('newS7GroupTable', {static: false}) newS7GroupTable?: BaseProtocolFormComponent;
  @ViewChild('newModbusMetricTable', {static: false}) newModbusMetricTable?: BaseProtocolFormComponent;
  @ViewChild('newS7MetricTable', {static: false}) newS7MetricTable?: BaseProtocolFormComponent;


  /**
   * All gateway-device types
   */
  deviceTypes: DeviceType[] = [];

  /**
   * DeviceType tabs for adding/editing a DeviceType
   */
  deviceTypeTabs: any[] = [
    {
      id: 0,
      text: "Informazioni"
    },
    {
      id: 1,
      text: "Misure"
    }
  ];

  /**
   * Selected DeviceType on tree list row click
   */
  selectedDeviceType?: DeviceType;

  /**
   * Copy of selected DeviceType, storing temporary changes (can roll back to selectedDeviceType if something goes wrong)
   */
  editedDeviceType?: DeviceType;

  /**
   * New DeviceType used when opening new DeviceType form
   */
  newDeviceType?: DeviceType = new DeviceType();

  /**
   * Enable lateral drawer form when true
   */
  isEditMode: boolean = false;

  /**
   * Tab selected DeviceType form (new/edit)
   */
  selectedDeviceTypeTab: number = 0;

  /**
   * Open new DeviceType dialog when true
   */
  addDeviceType: boolean = false;

  /**
   * Open delete DeviceType dialog when true
   */
  deletingDeviceType: boolean = false;

  /**
   * DeviceType being duplicated, opens the duplicate dialog when set
   */
  duplicatingDeviceType?: DeviceType;

  /**
   * Name for the new DeviceType, edited in the duplicate dialog
   */
  duplicateDeviceTypeName: string = '';

  /**
   * True if the user changed anything in edit DeviceType form
   */
  deviceTypeEdited: boolean = false;

  /**
   * True if new DeviceType is valid and can be saved
   */
  isNewFormValid: boolean | undefined = false;

  /**
   * True if edited DeviceType is valid and can be updated
   */
  isEditFormValid: boolean | undefined = false;

  /**
   * Id of the selected DeviceType in the main tree list (selected by clicking on a row)
   */
  selectedRowDeviceType: any;

  selectedGroupMetric?: MetricGroup;

  selectedGroupMetricRow: number[] = [];

  editedGroupMetric?: MetricGroup;

  manufacturers: Manufacturer[] = [];

  dataUnitValues: DataUnit[] = [];

  groupIsBeingEdited: boolean = false;

  metricIsBeingEdited: boolean = false;

  customDataUnitId: number = -1;

  protected readonly ProtocolTypeEnum = ProtocolTypeEnum;

  /**
   * Text box options for DeviceType fields
   */
  deviceTypeNewTextOptions = {
    valueChangeEvent: 'keyup',
  };

  deviceTypeNewTextAreaOptions = {
    valueChangeEvent: 'keyup',
    autoResizeEnabled: true
  };

  deviceTypeEditTextOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode
  };

  deviceTypeEditDelayMSOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    showClearButton: true
  };

  deviceTypeEditTextAreaOptions = {
    valueChangeEvent: 'keyup',
    disabled: !this.isEditMode,
    autoResizeEnabled: true
  };

  deviceTypeEditCheckBoxOptions = {
    disabled: !this.isEditMode
  };

  constructor() {
    super();
  }

  ngOnInit() {

    super.ngOnInit();
    this.getManufacturers();
    this.getDataUnits();
    this.getDeviceTypes();
  }

  /**
   * Get all gateway-device manufacturers
   */
  getManufacturers() {
    const cb = new GetManufacturersCB();

    this.deviceTypeOpeService.getManufacturers(cb).then((_) => {

      this.manufacturers = cb.o.manufacturers;

    });
  }

  /**
   * Get all Data Units for metrics
   */
  getDataUnits() {
    const cb = new GetDataUnitsCB();

    this.deviceTypeOpeService.getDataUnits(cb).then((_) => {

      this.dataUnitValues = cb.o.metricInstances;

    });
  }

  /**
   * Get all gateway-device types
   */
  getDeviceTypes() {
    const cb = new GetDeviceTypesCB();

    this.deviceTypeOpeService.getDeviceTypes(cb).then((_) => {

      this.deviceTypes = cb.o.deviceTypes;

      this.deviceTypeEdited = false;

      // if the drawer was already open, update the infos (probably a DeviceType has been updated)
      if (!!this.selectedDeviceType) {
        this.getDeviceType();
      }

    }).catch((error) => {
      if (!!this.selectedDeviceType)
        this.editedDeviceType = JSON.parse(JSON.stringify(this.selectedDeviceType));
    });
  }

  reorderDeviceMetrics() {
    this.selectedGroupMetric = JSON.parse(JSON.stringify(this.editedGroupMetric));
    if (!!this.selectedGroupMetric && !!this.selectedGroupMetric.metrics) {
      this.selectedGroupMetric.metrics.sort(
        (a, b) => {
          if (a.id !== undefined && b.id !== undefined)
            return a.id - b.id;
          else
            return -1;
        });
    }
  }

  /**
   * Get all gateway-device types
   */
  getDeviceType() {
    const cb = new GetDeviceTypeCB();

    cb.i.id = this.selectedDeviceType!.id;

    this.deviceTypeOpeService.getDeviceType(cb).then((_) => {

      this.selectedDeviceType = cb.o.deviceType;
      this.editedDeviceType = JSON.parse(JSON.stringify(this.selectedDeviceType));

      if (!!this.selectedGroupMetric && !!this.editedDeviceType?.metricGroups?.find(g => g.id === this.editedGroupMetric!.id)) {
        this.editedGroupMetric = this.editedDeviceType?.metricGroups?.find(g => g.id === this.editedGroupMetric!.id);
        this.reorderDeviceMetrics();
        this.selectedGroupMetricRow = [this.editedGroupMetric!.id!];
      } else {
        this.editedGroupMetric = undefined;
        this.selectedGroupMetric = undefined;
        this.selectedGroupMetricRow = [];
      }

      this.isDrawerOpen = true;

    }).catch((error) => {
      if (!!this.selectedDeviceType)
        this.editedDeviceType = JSON.parse(JSON.stringify(this.selectedDeviceType));
    });
  }

  /**
   * Add or update gateway-device type
   */
  putDeviceType(deviceType: DeviceType) {

    // create cb
    const cb = this.mapDeviceTypeToCB(deviceType!);

    if (!!cb.i.manufacturer && !!cb.i.manufacturer!.id && cb.i.manufacturer!.id < 0)
      cb.i.manufacturer!.id = undefined;

    for (let group of cb.i.metricGroups!) {
      if (isNaN(group.id!))
        group.id = undefined;

      for (let metric of group.metrics!) {
        if (isNaN(metric.id!))
          metric.id = undefined;

        if (!!metric.dataUnit && (isNaN(metric.dataUnit.id!) || metric.dataUnit.id! < 0))
          metric.dataUnit.id = undefined;
      }
    }

    if (!!this.editedGroupMetric && isNaN(this.editedGroupMetric!.id!)) {
      this.selectedGroupMetric = undefined;
      this.editedGroupMetric = undefined;
      this.selectedGroupMetricRow = [];
    }

    this.groupIsBeingEdited = false;
    this.metricIsBeingEdited = false;

    this.deviceTypeOpeService.putDeviceType(cb).then((_) => {

      this.addDeviceType = false;

      this.isNewFormValid = false;

      this.resetAllRowStates();

      if (!deviceType!.id)
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.CREATED"));
      else
        this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.UPDATED"));

      // reload gateway-device types list
      this.getManufacturers();
      this.getDataUnits();
      this.getDeviceTypes();

    }).catch((error) => {

      this.getManufacturers();
      this.getDataUnits();
      this.getDeviceTypes();
    });
  }

  mapDeviceTypeToCB(deviceType: DeviceType): PutDeviceTypeCB {
    const cb = new PutDeviceTypeCB();
    cb.i.id = deviceType.id;
    cb.i.modelName = deviceType.modelName;
    cb.i.partNumber = deviceType.partNumber;
    cb.i.modbusWritePauseMillis = deviceType.modbusWritePauseMillis;
    cb.i.protocolType = deviceType.protocolType;
    cb.i.manufacturer = deviceType.manufacturer ? {
      id: deviceType.manufacturer.id,
      name: this.manufacturers.find(m => m.id === deviceType.manufacturer!.id)!.name
    } : undefined;
    cb.i.metricGroups = deviceType.metricGroups?.map(group => ({
      id: group.id,
      name: group.name,
      transportConfiguration: {
        ...group.transportConfiguration,
        protocolType: this.getProtocolTypeValue(deviceType.protocolType)
      },
      metrics: group.metrics?.map(metric => ({
        id: metric.id,
        name: metric.name,
        dataUnit: !!metric.dataUnit && metric.dataUnit.id !== null ? {
          id: metric.dataUnit.id,
          name: this.dataUnitValues.find(d => d.id === metric.dataUnit!.id)!.name?? metric.dataUnit!.name
        } : undefined,
        divider: metric.divider,
        decimalDigits: metric.decimalDigits,
        transportConfiguration: {
          ...metric.transportConfiguration,
          protocolType: this.getProtocolTypeValue(deviceType.protocolType)
        }
      }))
    }));
    return cb;
  }

  /**
   * Open drawer when clicking on a tree list row (only if the event is not a click on the arrow to open the children)
   * @param $event
   */
  onDeviceTypeRowClick($event: any) {
    if (!this.selectedDeviceType) {
      this.selectedDeviceType = $event.data;
      this.getDeviceType();
    } else {
      if (this.selectedDeviceType!.id === $event.data.id) {
        this.closeDrawer();
      } else {
        this.switchDeviceType($event.data);
      }
    }
  }

  /**
   * Call putDeviceType ope with new gateway-device type
   */
  async createNewDeviceType() {
    this.checkNewDeviceTypeValidation();

    if (this.isNewFormValid) {
      if (!await this.confirmPendingRowEdits(this.newMetricTables)) return;
      this.putDeviceType(this.newDeviceType!);
    }
  }

  /**
   * Check if new gateway-device type is valid, to enable SAVE button
   */
  checkNewDeviceTypeValidation() {

    const result = this.newDeviceTypeForm.instance.validate();

    this.isNewFormValid = result.isValid && !!this.newDeviceType!.modelName && this.newDeviceType!.modelName.replace(/\s/g, "").length > 0;
  }

  /**
   * Check if edited DeviceType is valid, to enable SAVE button
   */
  checkEditDeviceTypeValidation() {
    if (!!this.editDeviceTypeForm) {
      const result = this.editDeviceTypeForm.instance.validate();

      this.isEditFormValid = result.isValid;

      this.deviceTypeEdited = this.isDeviceTypeEdited();

      this.appService.setRegistryEntityIsChanged(this.deviceTypeEdited && this.isEditMode);
    }
  }

  /**
   * Checks if the device type or its metric group has been edited
   * @returns true if any changes were made to the device type or metric group
   */
  isDeviceTypeEdited(): boolean {
    // Check if both objects exist
    if (!this.editedDeviceType || !this.selectedDeviceType) {
      return false;
    }

    // Compare basic properties
    if (
      this.editedDeviceType.id !== this.selectedDeviceType.id ||
      this.editedDeviceType.modelName !== this.selectedDeviceType.modelName ||
      this.editedDeviceType.partNumber !== this.selectedDeviceType.partNumber ||
      this.editedDeviceType.protocolType !== this.selectedDeviceType.protocolType ||
      this.editedDeviceType.modbusWritePauseMillis !== this.selectedDeviceType.modbusWritePauseMillis
    ) {
      return true;
    }

    // Compare manufacturer
    if (
      (this.editedDeviceType.manufacturer && !this.selectedDeviceType.manufacturer) ||
      (!this.editedDeviceType.manufacturer && this.selectedDeviceType.manufacturer) ||
      (this.editedDeviceType.manufacturer && this.selectedDeviceType.manufacturer &&
        this.editedDeviceType.manufacturer.id !== this.selectedDeviceType.manufacturer.id)
    ) {
      return true;
    }

    // Compare metric groups length
    if (
      (this.editedDeviceType.metricGroups?.length || 0) !==
      (this.selectedDeviceType.metricGroups?.length || 0)
    ) {
      return true;
    }

    // Compare metric groups content
    if (this.editedDeviceType.metricGroups && this.selectedDeviceType.metricGroups) {
      for (let i = 0; i < this.editedDeviceType.metricGroups.length; i++) {
        const editedGroup = this.editedDeviceType.metricGroups[i];
        const originalGroup = this.selectedDeviceType.metricGroups[i];

        if (
          editedGroup.id !== originalGroup.id ||
          editedGroup.name !== originalGroup.name ||
          editedGroup.isWritableOnEdge !== originalGroup.isWritableOnEdge ||
          JSON.stringify(editedGroup.transportConfiguration) !== JSON.stringify(originalGroup.transportConfiguration)
        ) {
          return true;
        }

        // Compare metrics length
        if ((editedGroup.metrics?.length || 0) !== (originalGroup.metrics?.length || 0)) {
          return true;
        }

        // Compare metrics content
        if (editedGroup.metrics && originalGroup.metrics) {
          // Create sorted copies of the metrics arrays
          const sortedEditedMetrics = [...editedGroup.metrics].sort((a, b) => {
            if (a.id !== undefined && b.id !== undefined)
              return a.id - b.id;
            else
              return -1;
          });

          const sortedOriginalMetrics = [...originalGroup.metrics].sort((a, b) => {
            if (a.id !== undefined && b.id !== undefined)
              return a.id - b.id;
            else
              return -1;
          });

          for (let j = 0; j < sortedEditedMetrics.length; j++) {
            const editedMetric = sortedEditedMetrics[j];
            const originalMetric = sortedOriginalMetrics[j];

            if (
              editedMetric.id !== originalMetric.id ||
              editedMetric.name !== originalMetric.name ||
              editedMetric.divider !== originalMetric.divider ||
              editedMetric.decimalDigits !== originalMetric.decimalDigits ||
              JSON.stringify(editedMetric.transportConfiguration) !== JSON.stringify(originalMetric.transportConfiguration) ||
              (editedMetric.dataUnit?.id !== originalMetric.dataUnit?.id)
            ) {
              return true;
            }
          }
        }
      }
    }

    // Check if metric group is edited
    if (this.editedGroupMetric && this.selectedGroupMetric) {
      if (
        this.editedGroupMetric.id !== this.selectedGroupMetric.id ||
        this.editedGroupMetric.name !== this.selectedGroupMetric.name ||
        this.editedGroupMetric.isWritableOnEdge !== this.selectedGroupMetric.isWritableOnEdge ||
        JSON.stringify(this.editedGroupMetric.transportConfiguration) !== JSON.stringify(this.selectedGroupMetric.transportConfiguration)
      ) {
        return true;
      }

      // Compare metrics length
      if ((this.editedGroupMetric.metrics?.length || 0) !== (this.selectedGroupMetric.metrics?.length || 0)) {
        return true;
      }

      // Compare metrics content
      if (this.editedGroupMetric.metrics && this.selectedGroupMetric.metrics) {
        // Create sorted copies of the metrics arrays
        const sortedEditedMetrics = [...this.editedGroupMetric.metrics].sort((a, b) => {
          if (a.id !== undefined && b.id !== undefined)
            return a.id - b.id;
          else
            return -1;
        });

        const sortedSelectedMetrics = [...this.selectedGroupMetric.metrics].sort((a, b) => {
          if (a.id !== undefined && b.id !== undefined)
            return a.id - b.id;
          else
            return -1;
        });

        for (let j = 0; j < sortedEditedMetrics.length; j++) {
          const editedMetric = sortedEditedMetrics[j];
          const originalMetric = sortedSelectedMetrics[j];

          if (
            editedMetric.id !== originalMetric.id ||
            editedMetric.name !== originalMetric.name ||
            editedMetric.divider !== originalMetric.divider ||
            editedMetric.decimalDigits !== originalMetric.decimalDigits ||
            JSON.stringify(editedMetric.transportConfiguration) !== JSON.stringify(originalMetric.transportConfiguration) ||
            (editedMetric.dataUnit?.id !== originalMetric.dataUnit?.id)
          ) {
            return true;
          }
        }
      }
    }

    return false;
  }

  /**
   * Enable form edit in drawer
   */
  enableEditMode() {
    this.isEditMode = true;
    this.deviceTypeEdited = false;
    this.updateDeviceTypeTextOptions();
  }

  /**
   * Disable form edit in drawer
   */
  disableEditMode() {

    if (this.isEditMode && (this.deviceTypeEdited || this.groupIsBeingEdited || this.metricIsBeingEdited)) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
        }
      });
    } else {
      this.resetDrawer();
    }

  }

  /**
   * Reset all drawer vars
   */
  resetDrawer() {
    this.resetAllRowStates();
    if (!!this.selectedDeviceType) {
      this.editedDeviceType = JSON.parse(JSON.stringify(this.selectedDeviceType));
    }
    if (!!this.editedGroupMetric) {
      this.editedGroupMetric = this.editedDeviceType?.metricGroups!.find(g => g.id === this.editedGroupMetric!.id);
      if (!!this.editedGroupMetric)
        this.selectedGroupMetric = JSON.parse(JSON.stringify(this.editedGroupMetric));
    }
    this.deviceTypeEdited = false;
    this.isEditMode = false;
    this.groupIsBeingEdited = false;
    this.metricIsBeingEdited = false;
    this.updateDeviceTypeTextOptions();
  }

  /**
   * Close lateral drawer
   */
  closeDrawer() {
    if (this.isEditMode && (this.deviceTypeEdited || this.groupIsBeingEdited || this.metricIsBeingEdited)) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.isDrawerOpen = false;
          this.selectedDeviceTypeTab = 0;
          this.resetDeviceTypeGrid();
        }
      });
    } else {
      this.resetDrawer();
      this.isDrawerOpen = false;
      this.selectedDeviceTypeTab = 0;
      this.resetDeviceTypeGrid();
    }
  }

  switchDeviceType(deviceType: DeviceType) {
    if (this.isEditMode && (this.deviceTypeEdited || this.groupIsBeingEdited || this.metricIsBeingEdited)) {
      this.showDiscardEditsDialog().show().done((dialogResult: any) => {
        if (dialogResult) {
          this.resetDrawer();
          this.selectedDeviceType = deviceType;
          this.selectedGroupMetric = undefined;
          this.editedGroupMetric = undefined;
          this.selectedGroupMetricRow = [];
          this.getDeviceType();
        } else {
          this.selectedRowDeviceType = [this.selectedDeviceType!.id];
        }
      });
    } else {
      this.resetDrawer();
      this.selectedDeviceType = deviceType;
      this.selectedGroupMetric = undefined;
      this.editedGroupMetric = undefined;
      this.selectedGroupMetricRow = [];
      this.getDeviceType();
    }

  }

  resetDeviceTypeGrid() {
    this.selectedDeviceType = undefined;
    this.editedDeviceType = undefined;
    this.selectedGroupMetric = undefined;
    this.editedGroupMetric = undefined;
    this.selectedRowDeviceType = [];
  }

  /**
   * Metrics-tab grids (groups + metrics) of the edit drawer, and of the "new device type" popup.
   */
  private get editMetricTables(): BaseProtocolFormComponent[] {
    return [this.modbusGroupTable, this.s7GroupTable, this.modbusMetricTable, this.s7MetricTable]
      .filter((t): t is BaseProtocolFormComponent => !!t);
  }

  private get newMetricTables(): BaseProtocolFormComponent[] {
    return [this.newModbusGroupTable, this.newS7GroupTable, this.newModbusMetricTable, this.newS7MetricTable]
      .filter((t): t is BaseProtocolFormComponent => !!t);
  }

  // Shared by each form's metric table and its group table (group rows' dot).
  readonly editMetricRowStateTracker = new RowStateTracker();
  readonly newMetricRowStateTracker = new RowStateTracker();

  focusActiveMetricEdit(): void {
    [this.modbusMetricTable, this.s7MetricTable, this.newModbusMetricTable, this.newS7MetricTable]
      .forEach(t => t?.focusActiveEdit());
  }

  get metricsRowStateTrackers(): RowStateTracker[] {
    return this.editMetricTables.map(t => t.rowStateTracker);
  }

  get newMetricsRowStateTrackers(): RowStateTracker[] {
    return this.newMetricTables.map(t => t.rowStateTracker);
  }

  private resetAllRowStates(): void {
    [...this.editMetricTables, ...this.newMetricTables].forEach(t => t.rowStateTracker.resetAll());
  }

  /**
   * Warns about rows left "in modifica" in `tables` before their form is saved; those edits were
   * never confirmed into the bound data and would be dropped silently. Returns false to abort.
   */
  private async confirmPendingRowEdits(tables: BaseProtocolFormComponent[]): Promise<boolean> {
    if (!tables.some(t => t.rowStateTracker.hasEditing())) return true;

    const proceed = await this.showSaveWithPendingEditDialogWithPromise();
    if (!proceed) return false;

    tables.forEach(t => t.cancelActiveEdit());
    return true;
  }

  async saveDeviceType() {
    if (!await this.confirmPendingRowEdits(this.editMetricTables)) return;

    this.isEditMode = false;
    this.updateDeviceTypeTextOptions();

    this.putDeviceType(this.editedDeviceType!);
  }

  /**
   * Show the new DeviceType dialog
   */
  showNewDeviceTypeForm() {
    this.newDeviceType = new DeviceType();
    this.newMetricRowStateTracker.resetAll();

    this.addDeviceType = true;
    this.cdr.detectChanges();
    this.newDeviceTypeForm.instance.clear();

  }

  /**
   * Update form fields when enabling/disabling edit mode
   */
  updateDeviceTypeTextOptions() {

    this.deviceTypeNewTextOptions = {
      valueChangeEvent: 'keyup',
    };

    this.deviceTypeNewTextAreaOptions = {
      valueChangeEvent: 'keyup',
      autoResizeEnabled: true
    };

    this.deviceTypeEditTextOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode
    };

    this.deviceTypeEditDelayMSOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode || this.editedDeviceType?.protocolType === ProtocolTypeEnum.SIEMENS_S7,
      showClearButton: true
    };

    this.deviceTypeEditTextAreaOptions = {
      valueChangeEvent: 'keyup',
      disabled: !this.isEditMode,
      autoResizeEnabled: true
    };

    this.deviceTypeEditCheckBoxOptions = {
      disabled: !this.isEditMode
    }
  }

  /**
   * Ope to delete a gateway-device type
   */
  deleteDeviceType() {

    // close delete DeviceType dialog
    this.deletingDeviceType = false;

    // create cb
    const cb: DelDeviceTypeCB = new DelDeviceTypeCB();
    cb.i.id = this.selectedDeviceType!.id;

    // call ope
    this.deviceTypeOpeService.delDeviceType(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.DELETED"));
      this.getDeviceTypes();
      this.isDrawerOpen = false;
      this.selectedDeviceType = undefined;
      this.selectedGroupMetric = undefined;
    });
  }

  /**
   * Open the duplicate DeviceType dialog, prefilling the new model name
   */
  openDuplicateDeviceType(deviceType: DeviceType) {
    this.duplicatingDeviceType = deviceType;
    const suffix = ' - ' + this.translate.instant('REGISTRY.DEVICE_TYPE.TEXT.DUPLICATE_DEVICE_TYPE_NAME_SUFFIX');
    this.duplicateDeviceTypeName = deviceType.modelName.slice(0, Math.max(this.gmService.STR_DIM_MID - suffix.length, 0)) + suffix;
  }

  /**
   * Ope to duplicate a gateway-device type
   */
  duplicateDeviceType() {
    const cb = new DuplicateDeviceTypeCB();
    cb.i.deviceTypeId = this.duplicatingDeviceType!.id;
    cb.i.modelName = this.duplicateDeviceTypeName;

    this.deviceTypeOpeService.duplicateDeviceType(cb).then((_) => {
      this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.DUPLICATED"));
      this.duplicatingDeviceType = undefined;
      this.getDeviceTypes();
    });
  }

  addNewManufacturer = (onCustomItemCreatingEvent: any) => {

    if (!onCustomItemCreatingEvent.text) {
      return;
    }

    const component = onCustomItemCreatingEvent.component;
    const dataSource = component.getDataSource();
    const dataStore = dataSource.store();

    // Cerca se l'item esiste già nel data store
    dataStore.load().then((items: any[]) => {
      let existingItem = items.find(item => item.name === onCustomItemCreatingEvent.text);

      if (existingItem) {
        // Se l'item esiste già, assegnalo all'evento
        onCustomItemCreatingEvent.customItem = existingItem;
      } else {
        // Se l'item non esiste, creane uno nuovo
        let newItem = {
          id: this.customDataUnitId--,
          name: onCustomItemCreatingEvent.text
        };

        onCustomItemCreatingEvent.customItem = newItem;

        dataStore.insert(newItem);
        dataSource.load();
      }

      let newManufacturer = new Manufacturer();
      newManufacturer.id = onCustomItemCreatingEvent.customItem.id;
      newManufacturer.name = onCustomItemCreatingEvent.customItem.name;

      if (!!this.selectedDeviceType && !!this.editedDeviceType)
        this.editedDeviceType!.manufacturer = newManufacturer;
      else
        this.newDeviceType!.manufacturer = newManufacturer;
    });

  };

  override setWidthOfDrawerPx(): number {
    if (this.isMobile) {
      return document.documentElement.clientWidth;
    } else if (this.isSmallScreen) {
      return document.documentElement.clientWidth * 0.8;
    } else {
      return document.documentElement.clientWidth * 0.8;
    }
  }

  async deleteManufacturer(manufacturer: Manufacturer, $event: ClickEvent) {
    $event.event?.stopPropagation();

    let result = this.showDeleteDialog(manufacturer.name).show().done();
    await result.then(async (dialogResult: any) => {
      if (dialogResult) {
        if (manufacturer.id! < 0) {
          this.manufacturers = this.manufacturers.filter(m => m.id !== manufacturer.id);
          this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.MANUFACTURER_DELETED"));
        } else {
          const cb = new DelManufacturerCB();
          cb.i.id = manufacturer.id!;

          this.deviceTypeOpeService.delManufacturer(cb).then((_) => {

            this.toastService.openSuccessToastMessage(this.translate.instant("REGISTRY.DEVICE_TYPE.TEXT.MANUFACTURER_DELETED"));

            this.getManufacturers();

          });
        }
      }
    });

  }

  checkIfUserCanChangeProtocol(editedDeviceType?: DeviceType) {
    if (editedDeviceType) {
      if (editedDeviceType.metricGroups) {
        return editedDeviceType.metricGroups.length > 0;
      }
    }
    return false;
  }

  resetDelayIfNotModbus = (event: any) =>  {
    if (event.value as ProtocolTypeEnum === ProtocolTypeEnum.SIEMENS_S7) {
      this.newDeviceType!.modbusWritePauseMillis = undefined;
    } else {
      if (!this.newDeviceType!.modbusWritePauseMillis) {
        this.newDeviceType!.modbusWritePauseMillis = 0;
      }
    }

    this.cdr.detectChanges()
  }

  onEditProtocolTypeChanged = (event: any) => {
    if (event.value as ProtocolTypeEnum === ProtocolTypeEnum.SIEMENS_S7) {
      this.editedDeviceType!.modbusWritePauseMillis = undefined;
    } else {
      if (!this.editedDeviceType!.modbusWritePauseMillis) {
        this.editedDeviceType!.modbusWritePauseMillis = 0;
      }
    }

    this.updateDeviceTypeTextOptions();
    this.cdr.detectChanges();
  }

}
